import React from 'react';
import { Toaster } from 'sonner';
import { PackageList } from './components/PackageList';
import { ESignPackagePanel } from './components/ESignPackagePanel';
import { usePackages } from './hooks/usePackages';
import { packages } from './data/packages';
export function App() {
  const {
    items,
    selected,
    selectedId,
    setSelectedId,
    busy,
    syncPackage,
    retryPdf,
    sendEmail,
    openSigning
  } = usePackages(packages);
  return <div className="min-h-screen w-full bg-[#b0c4df] font-sans text-ink" data-id="element-0" data-mp="2rlowqhk2dx92">
      <main className="mx-auto max-w-[1600px] space-y-3 p-3 md:p-4" data-id="element-1" data-mp="2mmlut5zds75b">
        <div className="grid items-start gap-3 lg:grid-cols-[300px_minmax(0,1fr)]" data-id="element-2" data-mp="31aqfgfhzusqq">
          <PackageList items={items} selectedId={selectedId} onSelect={setSelectedId} data-id="element-3" data-mp="31cjn9y4cfj0b" />
          <ESignPackagePanel pkg={selected} busy={busy[selected.id]} onSync={() => syncPackage(selected.id)} onRetryPdf={() => retryPdf(selected.id)} onSendEmail={sendEmail} onSign={openSigning} data-id="element-4" data-mp="2whx9joashed2" />
        </div>
      </main>
      <Toaster position="bottom-right" richColors data-id="element-5" data-mp="3ihv0i9zd8dgr" />
    </div>;
}